import { render, staticRenderFns } from "./modelIndex.vue?vue&type=template&id=76ba8824"
import script from "./modelIndex.vue?vue&type=script&lang=js"
export * from "./modelIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports